import React from "react";
import ReusableModal from "../../../../components/Modals/ReusableModal";

const ReferralSourceDeleteModal = ({
  isOpen,
  clearInput,
  data,
  onDeleteReferralSource,
  setOpen,
}) => {
  return (
    <ReusableModal
      open={isOpen}
      title={`Delete referral source`}
      onClose={() => {
        setOpen(false);
        clearInput();
      }}
    >
      <p className="p-3 text-base">
        Are you sure you want to delete referral source: {data?.name}?
      </p>
      <div className="flex justify-end">
        <div className="flex gap-2 m-3">
          <button
            className="w-28 disabled:opacity-40 disabled:cursor-not-allowed font-semibold p-2 border-[2px] rounded-md bg-subtleblue border-primaryblue text-primaryblue whitespace-nowrap"
            // onClick={clearInput}
            onClick={() => {
              setOpen(false);
              clearInput();
            }}
          >
            Cancel
          </button>
          <button
            className="w-28 disabled:opacity-40 disabled:cursor-not-allowed font-semibold p-2 rounded-md bg-primaryblue text-white whitespace-nowrap"
            onClick={async () => {
              await onDeleteReferralSource();
              setOpen(false);
              clearInput();
            }}
          >
            Delete
          </button>
        </div>
      </div>
    </ReusableModal>
  );
};

export default ReferralSourceDeleteModal;